<template>
  <div class="check-in">
    <drawer
      :title="addEditTitle"
      :dialogShow="handleEditShow"
      @handleChange="handleEditShow = false">
      <div slot="body">
        <div class="member-msg">
            <div class="member-border" v-if="memberList">
              <el-avatar class="img" shape="circle"
                :src="memberList.headImgUrl"  v-if="memberList.headImgUrl"></el-avatar>
              <el-avatar shape="circle" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box" v-if="memberList.id">
                <p>{{ memberList.nickName }}</p>
                <div class="flex-row mt5">
                  <p class="mobile">{{ memberList.mobile ? memberList.mobile : memberList.idCardNo}}</p>
                  <p>可用余额: <span class="fontSize18">￥{{ memberList.walletAmount }}</span></p>
                </div>
              </div>
              <div class="rows no-member" v-else>
                <p class="member-box">门店顾客</p>
              </div>
            </div>
          </div>
        <div class="pay-mains">
          <p class="order-title-boxs mtb24"><span class="blueBlock"></span><i>档案信息</i></p>
          <el-form
            ref="form"
            :model="form"
            class="demo-ruleForm"
            label-width="120px"
            label-position="left"
          >
       
            <div class="totals-box plr24">
              <div class="flex-row mb30">
                <div class="itemName">档案分类</div>
                <div class="itemNum">{{list.categoryName}}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">部位及个数</div>
                <div class="itemNum">{{list.symptom}}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">服务技师</div>
                <div class="itemNum">
                  <el-select v-model="repairForm.staffId" placeholder="请选择" class="w200" v-if="!updateFlag">
                    <el-option
                      v-for="item in staffOptions"
                      :key="item.value"
                      :label="item.staffName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <p v-else>{{repairForm.staffName}}</p>
                </div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">档案状态</div>
                <div class="itemNum">
                  <el-select v-model="status" placeholder="请选择" v-if="!updateFlag" @change="radioChange" class="w200">
                    <el-option label="进行中" :value="1"></el-option>
                    <el-option label="登记完成" :value="-1"></el-option>
                  </el-select>
                  <p v-else>{{repairForm.repairStatusCn}}</p>
                </div>
              </div>
              <div class="flex-row mb30" v-if="status != -1 && !repairForm.repairStatusCn">
                <div class="itemName">下次登记时间</div>
                <div class="itemNum">
                  <el-date-picker
                    class="dates w200"
                    v-model="nextRepairTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    align="right"
                    v-if="!updateFlag"
                    placeholder="选择日期>"
                  ></el-date-picker>
                  <p v-else>{{formatDay(nextRepairTime)}}</p> 
                </div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">登记照片（1-3张）</div>
                <div class="itemNum">
                  <imgUpload
                    @file="getFile"
                    :limit="3"
                    :imgHide="imgHide"
                    :fileList="repairForm.imgUrlList"
                    @delete="handleDelete"
                    module="repair"
                  ></imgUpload>
                </div>
              </div>
              <div class="flex-row mb30" v-if="status == -1">
                <div class="itemName">签名照片</div>
                <div class="itemNum">
                  <imgUploads
                    @file="getSignature"
                    :fileList="repairForm.signImgUrl"
                    @delete="signDelete"
                    module="repairSign"
                  ></imgUploads>
                </div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">登记备注</div>
                <div class="itemNum w100b">
                  <el-input
                    type="textarea"
                    :rows="3"
                    :autosize="{ minRows: 3, maxRows: 10}"
                    placeholder="请输入备注信息"
                    v-model="repairForm.remark"
                    maxlength="150"
                    show-word-limit
                    class="w100b"
                  ></el-input>
                </div>
              </div>
              <template v-if="isNeedSms && status == -1">
                <div class="flex-row mb30">
                  <div class="itemName">手机号码</div>
                  <div class="itemNum w100b">
                    <el-input
                      placeholder="请输入手机号码"
                      v-model="repairForm.validMobile"
                      maxlength="11"
                      class="w100b"
                    ></el-input>
                  </div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">短信验证</div>
                  <div class="itemNum relative flex-row w100b">
                    <el-input placeholder="输入验证码" maxlength="6" v-model="repairForm.verifyCode"></el-input>
                      <el-link
                        type="primary"
                        :underline="false"
                        class="small-btn sms-style"
                        @click="addLoginCode"
                        :disabled="!codeName"
                      >{{ codeName ? '发送验证码':time+'s'}}</el-link>
                  </div>
                </div>
              </template>
            </div>
          </el-form>
        </div>
        <div class="drawer-footer">
          <div class="btns pb10 pr24">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="saveMoney">提交</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <!-- <pay-set ref="paySetForm" @payChang="payChang" :status="status"></pay-set> -->
    <!-- 继续支付 -->
    <continue-pay ref="payForm" @change="handlePayChange"></continue-pay> 
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import paySet from "./pay";
import member from "../../components/member";
import imgUpload from "../../../components/common/modules/upload.vue";
import continuePay from "./continuePay.vue";
import imgUploads from "../../../components/common/modules/singleUpload";
import { encrypt } from '@/assets/javascript/untils'
export default {
  mixins: [minxin],
  components: { paySet, imgUpload, drawer, member ,continuePay ,imgUploads},
  data() {
    return {
      addEditTitle: "档案登记",
      handleEditShow: false,
      memberList: null,
      form: {
        recordList: []
      },
      imgHide: true,
      status: 1,
      nextRepairTime: '',
      repairForm: {
        id: "",
        imgUrlList: [],
        signImgUrl: '',
        remark: "",
        staffId: "",
        memberId: "",
        categoryId: "",
        repairDocumentId: "",
        validMobile: '', // 验证手机号
        verifyCode: '', // 验证码
        nextRepairTime: "" //new Date(),//下次修护时间
      },
      staffNames: "",
      headerImg: require("../../../assets/images/headerImg.png"),
      list: {},
      getForm: {
        documentId: "",
        symptom: ""
      },
      memberHide: true,
      formMobile: "",
      categoryId: "",
      memberId: "",
      newDocumentFlag: "",
      newOrOld: null,
      payPeriodFlag: false,
      updateFlag: false,
      finishRepairFlag: false,
      registrationNumber: '',
      userInfo: {
        shopBizConfig: {}
      },
      staffOptions: [],
      codeName: true,
      time: 60,
      isNeedSms: false
    };
  },
  created() {
    this.handleInit();
    
  },
  methods: {
    back () {
      this.handleEditShow = false;
    },
    radioChange (e) {
      console.log(this.memberList ? this.memberList.mobile:'');
      if (e == -1 && this.payPeriodFlag) {
          this.status = 1;
          this.$confirm('当前档案未完成全部收款！', '提示',{
              confirmButtonText: '继续收款',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
          }).then(() => {
              this.$refs["payForm"].$emit("set", {
                  id: this.repairForm.repairDocumentId,
                  memberId: this.repairForm.memberId
              })
          }).catch(() => {});
      } else {
        if (!this.finishRepairFlag) {
          this.status = 1;
          this.$message.error("已审核通过的档案登记次数不足3次，不能选择登记完成")
        }
      }
      if (this.status == -1 && this.isNeedSms) {
        this.repairForm.validMobile = this.memberList ? this.memberList.mobile:''
      } else {
        this.repairForm.signImgUrl = ''
        this.repairForm.validMobile = ''
      }
    },
    getStaffList () {
      this.$api.post(this.$url.companyShopStaff.listOnWork, {
        status: "enable"
      }).then(res => {
        if (res) {
          this.staffOptions = res;
        }
      })
    },
    memberChange(value) {
      this.repairForm.memberId = value;
      // this.repairForm.id = value;
      if (value != "") {
        this.$api
          .post(this.$url.repairDocument.getWithInput, {
            categoryId: this.repairForm.categoryId,
            memberId: this.repairForm.memberId
          })
          .then(res => {
            if (res.documentId) {
              this.getForm = res;
              this.repairForm.repairDocumentId = res.documentId;
              this.memberHide = true;
            } else {
              this.repairForm.repairDocumentId = "";
              this.memberHide = false;
            }
          });
      } else {
        this.memberHide = false;
      }
    },
    getMemberInfo() {
      this.$api.get(this.$url.member.get, {
        id: this.repairForm.memberId
      })
      .then(res => {
        if (res) {
          this.memberList = res;
          
        }
      })
      .catch(error => {});
    },
    handlePayChange (org) {
        if (org) {
            this.$emit("change",true)
            this.handleEditShow = false
        }
    },
    payChang (org) {
      if (org) {
        this.$emit("change",true)
        this.handleEditShow = false
      }
    },
    handleInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.userInfo = this.$store.getters.ShopInfo;
        this.newDocumentFlag = org.newDocumentFlag;
        this.payPeriodFlag = org.payPeriodFlag
        this.repairForm.repairDocumentId = org.repairForm.repairDocumentId;
        this.newOrOld = org.newOrOld;
        this.memberHide = true;
        this.handleEditShow = true;
        // this.repairForm = org;
        this.list.categoryName = org.categoryName;
        this.list.symptom = org.symptom;
        this.repairForm.categoryId = org.repairForm.categoryId;
        this.repairForm.memberId = org.repairForm.memberId;
        this.updateFlag = org.repairForm.updateFlag;
        this.finishRepairFlag = org.finishRepairFlag;
       console.log(org);
        if (org.repairForm.updateFlag) {
          // staffId: item.staffId,
          
          this.addEditTitle = "档案登记修改";
          this.repairForm.staffId = org.repairForm.staffId;
          this.repairForm.staffName = org.repairForm.staffName;
          this.nextRepairTime = this.formatDay(org.repairForm.nextRepairTime);
          this.repairForm.imgUrlList = org.repairForm.imgUrlList;
          this.repairForm.remark = org.repairForm.remark;
          this.repairForm.repairRecordId = org.repairForm.id;
          this.repairForm.repairStatusCn = org.repairForm.repairStatusCn;
          if (org.repairForm.imgUrlList.length >= 3) {
            this.imgHide = false;
          }
        }
        this.getStaffList();
        
        if (this.newDocumentFlag != 'paper') {
          this.getMemberInfo();
        } if (this.newDocumentFlag == 'paper' && this.repairForm.memberId) {
          this.getMemberInfo();
        }
        
        if (sessionStorage.getItem('appInit')) {
          let appInit = JSON.parse(sessionStorage.getItem('appInit'))
          this.isNeedSms = appInit.configManagerVo.documentRegister.verificationCodeFlag || false
        }
        // this.isNeedSms
      });
    },

    getFile(res) {
      this.repairForm.imgUrlList.push(res);
      console.log(this.repairForm);
      if (this.repairForm.imgUrlList.length >= 3) {
          this.imgHide = false
      }
    },
    handleDelete(res) {
      this.repairForm.imgUrlList = res.myFileList;
      this.ossMerchatDelImg(res);
      if (this.repairForm.imgUrlList.length < 3) {
          this.imgHide = true
      }
    },
    getSignature(res) {
      // 签名照片
      this.repairForm.signImgUrl = res;
      console.log(res);
    },
    signDelete (res) {
      this.form.imgUrlList = '';
      this.ossMerchatDelImg(res);
    },
    addLoginCode(type) {
      if (this.repairForm.validMobile == "") {
        this.$message.error("请输入手机号码");
        return false;
      }
      if (this.repairForm.validMobile.length != 11) {
        this.$message.error("请输入正确的手机号码");
        return false;
      }

      let arr = encrypt(
        JSON.stringify({
          mobile: this.repairForm.validMobile,
          bizType: "documentRegister",
          millisecond: new Date().getTime()
        })
      );
      this.$api.post(this.$url.send, arr).then(resp => {
        // if (resp) {
        //   this.codeName = false;
        // } else {
        //   this.codeName = true;
        //   clearInterval(auth_timetimer);
        // }
        this.codeName = false;
        this.time = 60;
      });
      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    saveMoney() {
      if (this.repairForm.staffId == "" && !this.form.repairRecordId) {
        this.$message.warning("请选择技师");
        return false;
      }
      if (this.status == -1 && !this.form.repairRecordId) {
        this.repairForm.nextRepairTime = -1;
      } else {
        if (this.nextRepairTime == ""  && !this.form.repairRecordId) {
          this.$message.warning("请选择下次登记时间");
          return false;
        }
        if (!this.form.repairRecordId) {
          this.repairForm.nextRepairTime = this.formatDay(this.nextRepairTime);
        }
      }
      if (this.status == -1 && !this.repairForm.signImgUrl) {
        this.$message.warning("请上传签名照片");
        return false;
      }
      if (this.repairForm.imgUrlList.length < 1) {
        this.$message.warning("至少上传1张图片");
        return false;
      }
      if (this.repairForm.remark == "") {
        this.$message.warning("请输入备注");
        return false;
      }
      if (this.status == -1 && this.isNeedSms && !this.repairForm.validMobile) return this.$message.warning("请输入手机号码")
      if (this.status == -1 && this.isNeedSms && this.repairForm.validMobile.length != 11) return this.$message.warning("请输入正确手机号码")
      if (this.status == -1 && this.isNeedSms && !this.repairForm.verifyCode) return this.$message.warning("请输入短信验证码")
      this.staffOptions.map(item => {
        if (item.id == this.repairForm.staffId) {
          this.repairForm.staffName = item.staffName;
        }
      })
      if (!this.repairForm.repairRecordId) {
        this.$confirm('您确定提交档案吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
            this.$api.post(this.$url.repairRecord.saveV2, this.repairForm).then(res => {
              if (res) {
                this.handleEditShow = false;
                this.$message.success(this.status == 1 ? '修改成功':'修护完成');
                this.payChang(true);
                // this.$refs["paySetForm"].$emit("set", res);
              }
            })    
        })
      } else {
        this.$confirm('您确定提交档案修改吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
            this.$api.post(this.$url.repairRecord.update, this.repairForm).then(res => {
              if (res) {
                this.handleEditShow = false;
                this.$message.success(this.status == 1 ? '修改成功':'修护完成');
                this.payChang(true);
              }
            })    
        })
      }
      
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.head-img {
  margin: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  .head_avater {
    width: 100%;
    padding: 24px;
    border-radius: 10px;
    border: 1px solid #EEEEEE;
  }
}
.sms-style {
  position: absolute;
  right: 10px;
  top: 25%;
}
.member-msg {
    padding: 16px 16px 0;
    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: #3388ff;
      box-sizing: border-box;
      .member-box {
        margin-left: 10px;
        .mobile {
          line-height: 1.6;
          margin-right: 46px;
        }
      }
    }
  }
.categroy-box {
  padding: 0 26px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .name {
    font-weight: 500;
    min-width: 100px;
  }
}
.select-staff {
  padding: 0 26px;
  min-height: 60px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.staff-btn {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  color: #8d8d8d;
  margin: 0;
}

.imgs-content {
  .right-img {
    padding: 16px;
    .head-title {
      margin-bottom: 15px;
    }
  }
  .no-top {
    border-top: 1px solid @borderColor;
    padding: 16px;
    .head-title {
      margin-bottom: 15px;
    }
  }
}
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>
